import React from "react";
import { HashRouter ,Route,Routes} from "react-router-dom";
import Home from "../Home/home"
import Contact from "../Contact/Contact";
import Skills from "../Skill/skill"
import Projects from "../Projects/Projects"
import About from "../About/About"
import  NavBar  from "../NavBar/NavBar";
import "./App.css"
import GoHome from "../GoHome/GoHome";

export default function App(props) {
    return <div className="App">
                <HashRouter>
                <NavBar/>
                    <Routes>
                          <Route path='/' element={<Home/>}/>
                          <Route path='/skills' element={<Skills/>}/>
                          <Route path='/contact' element={<Contact/>}/>
                          <Route path='/about' element={<About/>}/>
                    </Routes>
                    <GoHome/>
                </HashRouter>
          </div>
}